export default __webpack_public_path__ + "static/media/hr3.3c66ff24.png";